// extracted by mini-css-extract-plugin
export default {"player-wrapper":"responsive-player_player-wrapper__i5NdW","react-player":"responsive-player_react-player__parsv"};